<template>
  <el-dialog title="选择字典" :visible.sync="show" width="80%" custom-class="dict-select-dialog" append-to-body v-loading="loading">
    <div class="app-toolbar1">
      <el-input size="small" placeholder="请输入关键字模糊查询" v-model="name" clearable style="width:320px">
        <el-button slot="append" size="small" icon="el-icon-search" @click="load()">查询</el-button>
      </el-input>
    </div>
    <el-table :data="dictionaries" :stripe="true" size="mini" @current-change="select" @row-dblclick="selectAndNext" highlight-current-row>
      <el-table-column prop="dictionaryId" label="ID" width="80"></el-table-column>
      <el-table-column prop="name" label="字典名称"></el-table-column>
      <el-table-column prop="desc" label="字典描述" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="createTime" label="创建时间"></el-table-column>
      <el-table-column prop="updateTime" label="最后更新时间"></el-table-column>
    </el-table>
    <div slot="footer">
      <el-button size="mini" @click="show = false">取 消</el-button>
      <el-button size="mini" type="primary" @click="doSave">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'dict-select-dialog',
  data () {
    return {
      show: false,
      loaded: false,
      loading: false,
      dictionaries: [],
      selected: {},
      name: ''
    }
  },
  methods: {
    open () {
      this.show = true
      if (!this.loaded) {
        this.load()
      }
    },
    load () {
      this.loading = true
      this.$http.request({
        method: 'get',
        url: `/api/cgDictionaries?name=${this.name}`
      }).then(res => {
        this.dictionaries = res.data.data
        this.loaded = true
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    select (row) {
      this.selected = row || {}
    },
    selectAndNext (row) {
      this.selected = row || {}
      this.doSave()
    },
    doSave () {
      this.$emit('save', {
        dictionaryId: this.selected.dictionaryId,
        name: this.selected.name
      })
      this.show = false
    }
  }
}
</script>

<style>
.dict-select-dialog .el-dialog__body{padding:0;margin-top:10px;border-top:1px solid #ebeef5;}
</style>
